import type { AppearanceType } from '@atlaskit/avatar';

export function getAppearanceForAppType(appType: string | null | undefined): AppearanceType {
	switch (appType) {
		case 'agent':
			return 'hexagon';
		case 'team':
			// @TODO investigate if team comes from appType or if it is a separate way to detect
			return 'square';
		case 'user':
		case 'system':
		default:
			return 'circle';
	}
}
